import React from 'react'

import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

export const HotelTitleBlockLoading = () => (
  <div data-id="HotelTitleBlockLoading">
    <SkeletonLoader width={252} />
    <SkeletonLoader width={175} />
  </div>
)
